import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actualizarDatosParaMuiTable } from '../actions/TablaVolcadorasConCerealAsignadoActions'
import { TablaVolcadorasConCerealAsignadoView } from '../components/TablaVolcadorasConCerealAsignadoView'

class TablaVolcadorasConCerealAsignado extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaVolcadorasConCerealAsignadoView />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)
export default withRedux(TablaVolcadorasConCerealAsignado)
